import React,{ useRef, useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import _ from "lodash";

import { OverlayPanel } from "primereact/overlaypanel";
import { TabPanel, TabView } from "primereact/tabview";

import Notification from "./Notification";
import noNotificationImg from "../../../images/no notification.jpg"

import { Button } from "../../../helpers";

import { readNotifications } from "../../../services/api/adminNotificationMessage";
import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { fetchNotificationTypes } from "../../../services/redux/reducers/commonThunk"; 
import { fetchNotifications, updateNotifications } from "../../../services/redux/reducers/notifications/notifications";


const NewNotificationBar = () => {

    const [tabHeaders, setTabHeaders] = useState([ { header: "VIEW ALL", notificationTypeId: null }])
    const [activeTab, setActiveTab] = useState({
        index: 0,
        notificationTypeId: null
    })

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const userDetails = useSelector((state) => state.userDetails)
    const notifications = useSelector((state) => state.notifications.notifications)
    const notificationTypes = useSelector(state => state.common.notificationTypes)

    const op = useRef(null)

    const displayNotificationTypeIds = useMemo(() => {
        return _(notifications).map('notificationTypeId').filter(eachNotificationTypeId => eachNotificationTypeId && [1, 3, 4, 9].includes(eachNotificationTypeId)).uniq().value()
    }, [notifications])

    useEffect(() => {
        if (notificationTypes.length && displayNotificationTypeIds.length) {
            const headers = [
                { header: "VIEW ALL", notificationTypeId: null },
                ...displayNotificationTypeIds.map(eachNotificationTypeId => {
                    const notificationType = notificationTypes.find(type => type.notificationTypeId === eachNotificationTypeId)
                    return notificationType ? { header: notificationType.notificationType, notificationTypeId: eachNotificationTypeId } : null
                }).filter(header => header !== null)
            ]
            
            if (!_.isEqual(headers, tabHeaders)) {
                setTabHeaders(headers)
            }
        }
    }, [notificationTypes, displayNotificationTypeIds])

    useEffect(() => {
        dispatch(fetchNotificationTypes())
    }, [dispatch])

    useEffect(() => {
        if(userDetails.userId){
            const searchParams = {
                statusIds: [1],
                userIds: [userDetails.userId],
                notificationTypeIds: [1, 3, 4, 5, 6, 7, 9],
                paginator: false,
                isRead: false
            }
            dispatch(fetchNotifications(searchParams))
        }
    }, [userDetails])

    const handleTabChange = (e) => {
        const newIndex = e.index
        const newNotificationTypeId = tabHeaders[newIndex].notificationTypeId

        setActiveTab({
            index: e.index,
            notificationTypeId: newNotificationTypeId
        })
    }

    const routeToReferencePage = (routePath) => {
        navigate(routePath)
        op.current.hide()
    }

    const handleMarkAsRead = async (type, id) => {
        let data = {}
        data[type] = id

        const updatedNotificationRes = await readNotifications(userDetails.userId, data)
        if (updatedNotificationRes.failure){
            return dispatch(raiseToast({ severity: 'error', detail: updatedNotificationRes.data.error }))
        }else{
            let updatedNotifications = []
            if (type){
                updatedNotifications = notifications.filter(eachNotification => eachNotification[type] !== id)
            }
            dispatch(raiseToast({ severity: 'success', detail: 'Marked as Read' }))
            dispatch(updateNotifications(updatedNotifications))
        }
    }

    return(
        <>
            <div className="notification-icon-container mr-2" onClick={(e) => op.current.toggle(e)}>
                <i className='pi pi-bell mr-4 mt-2 text-lg notificationbar-icon notification-bell-button'></i>
                { notifications.length ? (<span className="notification-icon-dot"></span>) : "" }
            </div>

            <OverlayPanel ref={op} style={{ borderRadius: "10px"}}>
                <div className="notification-container flex flex-column"> 
                    <div className="notification-header">
                        <h3>Notifications</h3>
                        <Button icon="pi pi-times" style={{ color: "grey", padding: "5px", fontSize: "0.5rem", border: "1px solid lightgrey" }} onClick={(e) => op.current.toggle(e)} outlined/>
                    </div>

                    { notifications.length ? 
                        <div className="notification-header-tab flex flex-column justify-content-between" style={{flexGrow: "inherit"}}>
                            <TabView activeIndex={activeTab.index}  onTabChange={(e) => handleTabChange(e, null)}>
                                <TabPanel header="VIEW ALL">
                                    <div className="notification-list">
                                        { 
                                            notifications.map(eachNotification => {
                                                return <Notification 
                                                    notification={eachNotification} 
                                                    handleMarkAsRead={handleMarkAsRead} 
                                                    routeToReferencePage={routeToReferencePage}
                                                    key={eachNotification.notificationId} 
                                                />
                                            })
                                        }
                                    </div>
                                </TabPanel>
                                {
                                    displayNotificationTypeIds.length ?
                                    displayNotificationTypeIds.map((eachNotificationTypeId, index) => {
                                        const relatedNotificationType = notificationTypes.find(eachNotificationType => eachNotificationType.notificationTypeId === eachNotificationTypeId)
                                        const relatedNotifications = notifications.filter(eachNotification => eachNotification.notificationTypeId === eachNotificationTypeId)
                                        let notificationType = ""
                                        if (relatedNotificationType){
                                            notificationType = relatedNotificationType.notificationType
                                        }
                                        return (                                    
                                            <TabPanel key={index} header={notificationType} onTabChange={(e) => handleTabChange(e, eachNotificationTypeId)}>
                                                <div className="notification-list">
                                                    {
                                                        relatedNotifications.map(eachNotification => {
                                                            return <Notification 
                                                                notification={eachNotification} 
                                                                handleMarkAsRead={handleMarkAsRead} 
                                                                routeToReferencePage={routeToReferencePage}
                                                                key={eachNotification.notificationId} 
                                                            />
                                                        })
                                                    }
                                                </div>
                                            </TabPanel>
                                        )
                                    })
                                    :
                                    null
                                }
                            </TabView>
                            <div className="notification-footer flex align-self-start">
                                <Button label="Mark all as read" icon="pi pi-check" text style={{ fontSize: "12px", color: "blue"}} onClick={() => handleMarkAsRead(activeTab.index === 0 ? null : "notificationTypeId", activeTab.notificationTypeId)}/>
                            </div>
                        </div>
                    : 
                        <div className="no-notification-message flex flex-column justify-content-center align-items-center " style={{ width: "320px", height: "450px" }}>
                            <img src={noNotificationImg} alt="No Notifications" className="no-notifications-img" style={{ width: "170px", height: "170px" }} />
                        </div>
                    }
                </div>
            </OverlayPanel>
        </> 
    )
}

export default NewNotificationBar;